export interface LogoProps {
  width?: string;
}

export function Logo({ width = "30" }: LogoProps) {
  return (
    <svg
      width={width}
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0704 17.9695C26.4866 20.913 29.0786 25.1248 30 28H26.0986C25.2459 25.7451 23.1428 22.4519 21.4492 20.666L24.0704 17.9695ZM29.9973 0V7.2408L19.4291 18.1219C18.889 17.5238 18.3358 16.9384 17.7699 16.3662C11.7909 10.3081 5.65212 6.75326 4.01469 8.41165C2.74225 9.70085 4.60555 13.7117 8.07941 18.089L6.62725 19.5778C3.96256 16.2965 1.91268 12.9559 0.841924 10.1411C0.0123415 7.95839 -0.536358 5.23424 0.833041 3.82533C2.05955 2.56263 4.54187 2.69125 7.81671 4.20114C11.1375 5.73342 14.9342 8.50623 18.4413 11.8993L29.9973 0ZM12.8945 17.6067C13.34 17.8998 14.1248 18.6409 14.7527 19.2888C15.3435 19.8984 16.1003 20.7094 16.4298 21.2033L9.83153 28H2.79972L12.8945 17.6067Z"
        fill="white"
      />
    </svg>
  );
}
